import { analytics } from '~/analytics';
import { cookies } from '~/cookie';

export const signOut = async () => {
  cookies.remove('session');
  cookies.remove('redirect');
  analytics.reset();

  localStorage.clear();

  window.location.href = '/';
};
